/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function GoogleLogoLarge(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'GoogleLogoLarge',
      'aria-hidden': true,
      focusable: false,
      width:  36 * scale,
      height: 36 * scale,
      viewBox: '0 0 36 36',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","fillRule":"evenodd","d":"M34.773 14.727H18v6.955h9.655c-.9 4.418-4.664 6.954-9.655 6.954A10.615 10.615 0 0 1 7.364 18c0-5.89 4.745-10.636 10.636-10.636 2.536 0 4.827.9 6.627 2.372L29.864 4.5C26.673 1.718 22.582 0 18 0 8.018 0 0 8.018 0 18s8.018 18 18 18c9 0 17.182-6.545 17.182-18 0-1.064-.164-2.21-.41-3.273z"}))
}
